/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sign_In_To_See_DevicesInputs */

const th_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าสู่ระบบเพื่อดูว่าบัญชีของคุณถูกใช้งานที่ใดบ้าง`)
};

const en_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to see where your account is being used.`)
};

const ja_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントがどこで使われているか見るにはログインしてください。`)
};

const zh_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录后可查看你的账户在哪里被使用。`)
};

const es_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión para ver dónde se está usando tu cuenta.`)
};

const pt_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre para ver onde sua conta está sendo usada.`)
};

const id_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk untuk melihat di mana akun Anda dipakai.`)
};

const fr_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous pour voir où votre compte est utilisé.`)
};

const tl_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-sign in para makita kung saan ginagamit ang account mo.`)
};

const vi_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập để xem tài khoản bạn đang được dùng ở đâu.`)
};

const ko_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정이 어디서 쓰이는지 보려면 로그인하세요.`)
};

const de_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melde dich an, um zu sehen, wo dein Konto benutzt wird.`)
};

const ru_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите, чтобы увидеть, где используется ваш аккаунт.`)
};

const tr_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesabınızın nerede kullanıldığını görmek için giriş yapın.`)
};

const it_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi per vedere dove viene usato il tuo account.`)
};

const pl_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się, aby zobaczyć, gdzie używane jest twoje konto.`)
};

const uk_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увійдіть, щоб побачити, де використовується ваш обліковий запис.`)
};

const hi_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह देखने के लिए साइन इन करें कि आपका खाता कहाँ उपयोग हो रहा है।`)
};

const ar_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجّل الدخول لترى أين يُستخدم حسابك.`)
};

const ms_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk untuk melihat di mana akaun anda digunakan.`)
};

const bn_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার অ্যাকাউন্ট কোথায় ব্যবহৃত হচ্ছে তা দেখতে সাইন ইন করুন।`)
};

const zh_tw2_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入後可查看你的帳戶在哪裡被使用。`)
};

const zh_hk2_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入後可查看你的帳戶在哪裡被使用。`)
};

const ur_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اپنا اکاؤنٹ کہاں استعمال ہو رہا ہے یہ دیکھنے کے لیے سائن اِن کریں۔`)
};

const fa_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برای دیدن اینکه حساب‌تان کجا به کار می‌رود وارد شوید.`)
};

const sw_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingia ili kuona akaunti yako inatumika wapi.`)
};

const nl_sign_in_to_see_devices = /** @type {(inputs: Sign_In_To_See_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in om te zien waar je account wordt gebruikt.`)
};

/**
* | output |
* | --- |
* | "Sign in to see where your account is being used." |
*
* @param {Sign_In_To_See_DevicesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const sign_in_to_see_devices = /** @type {((inputs?: Sign_In_To_See_DevicesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sign_In_To_See_DevicesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_sign_in_to_see_devices(inputs)
	if (locale === "ja") return ja_sign_in_to_see_devices(inputs)
	if (locale === "zh") return zh_sign_in_to_see_devices(inputs)
	if (locale === "es") return es_sign_in_to_see_devices(inputs)
	if (locale === "pt") return pt_sign_in_to_see_devices(inputs)
	if (locale === "id") return id_sign_in_to_see_devices(inputs)
	if (locale === "fr") return fr_sign_in_to_see_devices(inputs)
	if (locale === "tl") return tl_sign_in_to_see_devices(inputs)
	if (locale === "vi") return vi_sign_in_to_see_devices(inputs)
	if (locale === "ko") return ko_sign_in_to_see_devices(inputs)
	if (locale === "de") return de_sign_in_to_see_devices(inputs)
	if (locale === "ru") return ru_sign_in_to_see_devices(inputs)
	if (locale === "tr") return tr_sign_in_to_see_devices(inputs)
	if (locale === "it") return it_sign_in_to_see_devices(inputs)
	if (locale === "pl") return pl_sign_in_to_see_devices(inputs)
	if (locale === "uk") return uk_sign_in_to_see_devices(inputs)
	if (locale === "hi") return hi_sign_in_to_see_devices(inputs)
	if (locale === "ar") return ar_sign_in_to_see_devices(inputs)
	if (locale === "ms") return ms_sign_in_to_see_devices(inputs)
	if (locale === "bn") return bn_sign_in_to_see_devices(inputs)
	if (locale === "zh-TW") return zh_tw2_sign_in_to_see_devices(inputs)
	if (locale === "zh-HK") return zh_hk2_sign_in_to_see_devices(inputs)
	if (locale === "ur") return ur_sign_in_to_see_devices(inputs)
	if (locale === "fa") return fa_sign_in_to_see_devices(inputs)
	if (locale === "sw") return sw_sign_in_to_see_devices(inputs)
	if (locale === "nl") return nl_sign_in_to_see_devices(inputs)
	return en_sign_in_to_see_devices(inputs)
});